import { Box } from '@mui/material';
import { Dialog, TextField } from 'components/commons';
import ja from 'utils/ja';
interface SearchTagDialogProps {
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void;
  value: string;
  setValue: (val: string) => void;
}

const SearchTagDialog = ({
  open,
  onClose,
  handleConfirm,
  value,
  setValue,
}: SearchTagDialogProps) => {
  return (
    <Dialog
      open={open}
      handleClose={onClose}
      title={ja.tag.dialog_search.title}
      handleConfirm={handleConfirm}
      isSearch
    >
      <Box
        sx={{
          width: { xs: '80vw', sm: '500px' },
          padding: '10px',
          '& *': {
            fontSize: '18px !important',
          },
        }}
      >
        <TextField
          id='tagName'
          label={ja.tag.tags}
          placeholder={ja.tag.content}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </Box>
    </Dialog>
  );
};
export default SearchTagDialog;
